import router from "./router";
import i18n from "./i18n";

export const shopModuleRouter = router;
export const shopModuleI18n = i18n;
